export default __webpack_public_path__ + "static/portfolio_gallery_24-1577ea1f2dadf148a3366a5a0433bf38.jpg";